export function partition<T>(array: T[], splitCondition: (value: T) => boolean): [T[], T[]] {
  return array.reduce(
    (acc, value) => (acc[splitCondition(value) ? 0 : 1].push(value), acc),
    [[] as T[], [] as T[]]
  )
}
